module.exports = __webpack_public_path__ + "img/wocozon-inverted.3e608769.svg";